import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { Select } from "antd";
import jalaliday from "jalaliday";
import { GrowingSeasonYear } from "@/features/growing-season/domain/growing-season.interface";
import { GrowingSeasonRepositoryImpl } from "@/features/growing-season/data/repositories/growing-season-repositories";

dayjs.extend(jalaliday);

interface SelectionProps {
  index: string;
  type: "growingSeason" | "productId" | "irrigationSystemId" | any;
  onChange: (value: any, option: any) => void;
  defaultValue: any;
  disabled: boolean;
}

const Selection = ({
  index,
  type,
  onChange,
  defaultValue,
  disabled,
}: SelectionProps) => {
  // consts
  const growingSeasonRepository = new GrowingSeasonRepositoryImpl();

  // @ts-ignore
  dayjs.calendar("jalali");

  // state
  const [options, setOptions] = useState<any>([]);
  const [growingSeasonYears, setGrowingSeasonYears] = useState<
    GrowingSeasonYear[]
  >([]);
  const productsQuery = useQuery(
    ["staticProducts"],
    growingSeasonRepository._getProducts,
    { enabled: type === "productId" }
  );

  const irrigationSystemsQuery = useQuery(
    ["irrigationSystems"],
    growingSeasonRepository._getIrrigationSystems,
    { enabled: type === "irrigationSystemId" }
  );

  // lifeCycles
  useEffect(() => {
    if (productsQuery.data && type === "productId") {
      setOptions(
        productsQuery.data.map((product) => ({
          label: product.persianName,
          value: product.id,
          type: product.type,
        }))
      );
    }
  }, [productsQuery.data, type]);

  useEffect(() => {
    if (type === "growingSeason") {
      const thisYear = Number(
        dayjs(new Date().getFullYear().toString()).format("YYYY")
      );

      for (let index = thisYear + 2; index >= thisYear - 38; index--) {
        setGrowingSeasonYears((prev) => [
          ...prev,
          { label: index, value: index },
        ]);
      }
    }
  }, []);
  useEffect(() => {
    if (type === "growingSeason" && growingSeasonYears.length > 0) {
      setOptions(growingSeasonYears);
    }
  }, [growingSeasonYears]);

  useEffect(() => {
    if (irrigationSystemsQuery.data && type === "irrigationSystemId") {
      setOptions(
        irrigationSystemsQuery.data.map((irrigationSystem) => ({
          label: irrigationSystem.name,
          value: irrigationSystem.id,
        }))
      );
    }
  }, [irrigationSystemsQuery.data, type]);
  return (
    <Select
      key={index}
      showSearch
      defaultValue={defaultValue}
      onChange={onChange}
      options={options}
      disabled={disabled}
      optionFilterProp="label"
      className="button-neo !w-[240px] py-1 rounded-3xl max-lg:p-1 max-lg:text-[12px]"
      placeholder="انتخاب کنید"
    />
  );
};

export default Selection;
